export enum ScriptId {
    ShowPersistentBanner = 'show-banner',
    SetupDataLayer = 'setup-data-layer',
    MarketingVideoLibrary = 'caast_library',
}
